import './Biography.css';
import useScreenWidth from '../../hooks/useScreenWidth';
import BiographyCard from '../../components/BiographyCard/BiographyCard';
import { useEffect, useState } from 'react';

const Biography: React.FC = () => {
    const [isVisible, setVisible] = useState<boolean>(false);
    const screenWidth = useScreenWidth();

    useEffect(() => {
        setVisible(true);
    }, []);
    
    let text1 = `
        Я родилась 25 апреля 1987 года в Ленинграде (ныне Санкт-Петербург) в семье с богатыми творческими традициями. Мои родители, 
        Александр и Екатерина, передали мне любовь к искусству, эстетике и стремление к совершенству. Отец привил мне терпение и аккуратность, 
        а мама — умение не останавливаться на пути к цели и веру в то, что всё возможно.
    `
    
    let text2 = `
        Несмотря на семейную склонность к творчеству, я окончила 292-ю математическую школу и получила высшее образование в СПбГУВК по специальности 
        "Антикризисное управление". После короткого периода работы в бухгалтерии я посвятила себя семье и воспитанию четверых замечательных детей.
    `
    
    let text3 = `
        В течение 15 лет декретного отпуска я исследовала различные творческие направления и кулинарию, мечтая о собственной мастерской. 
        Так родилась идея создания кластера MIARTCOM — пространства, объединяющего разные виды искусства и творчества, где каждый может найти что-то для себя.
    `
    
    return (
        <div className="biography">
            <h3>Здравствуйте!{screenWidth <= 450 ? <br /> : <></>} Меня зовут Мария Осипова, <br /> я основатель пространства <b>MIARTCOM</b>.</h3>

            <div className={`biography_cards ${isVisible ? 'visible' : ''}`}>
                <BiographyCard imgUrl={`${process.env.REACT_APP_IMG_URL}/BiographyImg/BiographyImg1S.jpeg`} desc={text1} />
                <BiographyCard imgUrl={`${process.env.REACT_APP_IMG_URL}/BiographyImg/BiographyImg2S.jpeg`} desc={text2} />
                <BiographyCard imgUrl={`${process.env.REACT_APP_IMG_URL}/BiographyImg/BiographyImg3S.jpeg`} desc={text3} />
            </div>
        </div>
    )
};

export default Biography;